import { render, staticRenderFns } from "./RichTextEditorParser.vue?vue&type=template&id=0b0cd7ac&"
import script from "./RichTextEditorParser.vue?vue&type=script&lang=js&"
export * from "./RichTextEditorParser.vue?vue&type=script&lang=js&"
import style0 from "./RichTextEditorParser.vue?vue&type=style&index=0&id=0b0cd7ac&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports